/* eslint-disable jira/filename-case */
import {
	USER_SEGMENTATION_TEAM_TYPE_DESIGN,
	USER_SEGMENTATION_TEAM_TYPE_IT_SUPPORT,
	USER_SEGMENTATION_TEAM_TYPE_MARKETING,
	USER_SEGMENTATION_TEAM_TYPE_OPERATIONS,
	USER_SEGMENTATION_TEAM_TYPE_OTHER_PERSONAL,
	USER_SEGMENTATION_TEAM_TYPE_PRODUCT_MANAGEMENT,
	USER_SEGMENTATION_TEAM_TYPE_PROJECT_MANAGEMENT,
	USER_SEGMENTATION_TEAM_TYPE_SOFTWARE,
} from '@jira/platform__onboarding-core/src/constants.tsx';

export const tailoredTeamTypes: readonly ['DES', 'ITS', 'MKT', 'OPS', 'OTR', 'PDM', 'PJM', 'DEV'] =
	[
		USER_SEGMENTATION_TEAM_TYPE_DESIGN,
		USER_SEGMENTATION_TEAM_TYPE_IT_SUPPORT,
		USER_SEGMENTATION_TEAM_TYPE_MARKETING,
		USER_SEGMENTATION_TEAM_TYPE_OPERATIONS,
		USER_SEGMENTATION_TEAM_TYPE_OTHER_PERSONAL,
		USER_SEGMENTATION_TEAM_TYPE_PRODUCT_MANAGEMENT,
		USER_SEGMENTATION_TEAM_TYPE_PROJECT_MANAGEMENT,
		USER_SEGMENTATION_TEAM_TYPE_SOFTWARE,
	] as const;

export const tailoredM2P5TeamTypes: readonly ['DES', 'ITS', 'OTR', 'PDM', 'PJM', 'DEV'] = [
	USER_SEGMENTATION_TEAM_TYPE_DESIGN,
	USER_SEGMENTATION_TEAM_TYPE_IT_SUPPORT,
	USER_SEGMENTATION_TEAM_TYPE_OTHER_PERSONAL,
	USER_SEGMENTATION_TEAM_TYPE_PRODUCT_MANAGEMENT,
	USER_SEGMENTATION_TEAM_TYPE_PROJECT_MANAGEMENT,
	USER_SEGMENTATION_TEAM_TYPE_SOFTWARE,
] as const;
